var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { getServerTime } from '../module/server-time';
function record() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var goldlog = window.goldlog && window.goldlog.record ? window.goldlog.record : console.error;
    return goldlog.apply(void 0, __spread(args));
}
export default (function (_a) {
    var key = _a.key, _b = _a.type, type = _b === void 0 ? 'CLK' : _b, _c = _a.method, method = _c === void 0 ? 'GET' : _c, _d = _a.data, data = _d === void 0 ? {} : _d, _e = _a.config, config = _e === void 0 ? {} : _e;
    var sellerId = config.sellerId, sellerUserId = config.sellerUserId, region = config.region;
    var dataObj = __assign({ app_key: config.appKey, app_version: config.appVersion, seller_id: sellerId, country: region, region: region, seller_uid: sellerUserId, seller_user_id: sellerUserId, log_time: getServerTime(config) }, data);
    var paramStr = Object.keys(dataObj)
        .filter(function (key) { return dataObj[key]; })
        .map(function (key) { return key + "=" + dataObj[key]; }).join('&');
    record(key, type, paramStr, method);
});
